import type React from 'react';
import { useEffect } from 'react';
import { Toast, useToast } from '@zillow/constellation-10';

import type { LeaseActionProps } from '../../../models/Types';
import { downloadFileFromUrl } from '../../../utils/urlUtils';
import { logError } from '@zg-rentals/log-error';
import { DOWNLOAD_TOAST_MESSAGES } from '../../../constants/stringConstants';
import { GetLeaseHelpButton } from '../../Widgets/GetLeaseHelpButton';

export default function DownloadLeasePdf({ lease, terminateActiveAction }: LeaseActionProps): React.ReactNode {
  const { enqueueToast } = useToast();

  const onFileDownloadedSuccessToast = () => {
    enqueueToast(<Toast tone="success">{DOWNLOAD_TOAST_MESSAGES.LEASE_SUCCESS}</Toast>);
  };

  const onFileDownloadedErrorToast = () => {
    enqueueToast(
      <Toast tone="critical" actionButton={<GetLeaseHelpButton onImpact />}>
        {DOWNLOAD_TOAST_MESSAGES.LEASE_ERROR}
      </Toast>,
    );
  };

  useEffect(() => {
    // eslint-disable-next-line promise/catch-or-return
    downloadFileFromUrl(lease.getPDFLink())
      // eslint-disable-next-line promise/always-return
      .then(() => {
        onFileDownloadedSuccessToast();
      })
      .catch((err) => {
        logError({ error: err, context: 'DownloadLeasePdf - download failed' });
        onFileDownloadedErrorToast();
      })
      .finally(() => {
        terminateActiveAction();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
